/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ImmovableAssetItemImmovableSubType =
  (typeof ImmovableAssetItemImmovableSubType)[keyof typeof ImmovableAssetItemImmovableSubType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImmovableAssetItemImmovableSubType = {
  house: "house",
  apartment: "apartment",
  cabin: "cabin",
  land: "land",
  forest: "forest",
  other: "other",
} as const;
